export class UserRegistrationResultDto {
  UserId: number;
  FullName: string;
  IsNewUser: boolean;
  Action: UserRegistrationActionEnum;
  ActionString: string;
  UserName: string;
  Password: string;
  PacketType?: string;
  /** WI 37725: the type as HR names it (New Hire, Rehire, Re-Sign; never PVF). */
  PacketTypeName?: string | null;
  /** WI 37725: why registration chose that type, as stored on the packet. */
  RegistrationReason?: string | null;
  /** True when a fresh open packet for this person and company already existed (WI 34384): nothing changed. */
  AlreadyRegistered?: boolean;
  PacketId?: number | null;
  /**
   * True when AlreadyRegistered is true, the matched user still has no login, and HR did not confirm this
   * re-registration, so provisioning was not retried (WI 34384). Confirming re-registration retries it.
   */
  NeedsLoginSetup?: boolean;
}

// so the precheck sees these enums with set values and thinks they are variables...
// of course not all of the values are used so it raises no-unused-vars rule
// (only in the precheck though, not in VSC)
/* eslint-disable no-unused-vars */
export enum UserRegistrationActionEnum {
  None = 0,
  Register = 1,
  Rehire = 2,
}

export enum MessageCodeEnums {
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  USER_PROFILE_NOT_RESOLVED = 'USER_PROFILE_NOT_RESOLVED',
  USER_CANT_BE_REREGISTERED = 'USER_CANT_BE_REREGISTERED',
  USER_ALREADY_REGISTERED = 'USER_ALREADY_REGISTERED',
  PACKET_NOT_FOUND = 'PACKET_NOT_FOUND',
}

export enum UserRegisterMessageCodeEnums {
  REGISTRATION_FIRST_NAME_REQUIRED = 'REGISTRATION_FIRST_NAME_REQUIRED',
  REGISTRATION_LAST_NAME_REQUIRED = 'REGISTRATION_LAST_NAME_REQUIRED',
  REGISTRATION_DOB_TOO_YOUNG = 'REGISTRATION_DOB_TOO_YOUNG',
  REGISTRATION_DOB_OUT_OF_RANGE = 'REGISTRATION_DOB_OUT_OF_RANGE',
}
